// src/components/roadmap/DevelopmentPhilosophy.tsx
import React from 'react';
import { motion } from 'framer-motion';
import { Target, Users, Layers } from 'lucide-react';
import { ContentCard } from '@dopomogai/ui';

// Matches the data structure from `roadmap.json`
interface PhilosophyCardData {
  title: string;
  text: string;
}
interface PhilosophyData {
  headline: string;
  card1: PhilosophyCardData;
  card2: PhilosophyCardData;
  card3: PhilosophyCardData;
}
interface DevelopmentPhilosophyProps {
  philosophyData: PhilosophyData;
}

export const DevelopmentPhilosophy: React.FC<DevelopmentPhilosophyProps> = ({ philosophyData }) => {
  const principles = [
    {
      icon: <Target size={28} className="text-emerald-500" />,
      ...philosophyData.card1,
    },
    {
      icon: <Users size={28} className="text-sky-500" />,
      ...philosophyData.card2,
    },
    {
      icon: <Layers size={28} className="text-purple-500" />,
      ...philosophyData.card3,
    },
  ];

  return (
    <section className="bg-slate-100 py-16 md:py-24">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900">
            {philosophyData.headline}
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
          {principles.map((principle, index) => (
            // Reusing the ContentCard for a consistent "neobrutalist" lift effect
            <ContentCard
              key={index}
              index={index}
              icon={
                <div className="p-3 bg-white border-2 border-black rounded-lg inline-block">
                  {principle.icon}
                </div>
              }
              title={principle.title}
              text={principle.text}
              hoverEffect="lift"
              className="text-center"
              contentClassName="p-6 flex flex-col items-center"
              titleClassName="mt-2"
            />
          ))}
        </div>
      </div>
    </section>
  );
};

